module.exports = __webpack_public_path__ + "img/table-data.450f047b.svg";